import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { SHORT_DATE_FORMAT } from '../../../constants';
import TimeSlotRadioButton from './TimeSlotRadioButton';
import { uniqTimeslots } from '../../../utilities/helperUtility';

export default class TimeSlotRadioButtons extends Component {
  parseTimeSlots() {
    const { timeslots, availableDates, selectedDate } = this.props,
          day = dayjs(selectedDate).format(SHORT_DATE_FORMAT);

    if (!timeslots.length || !availableDates.includes(day)) return [];

    return uniqTimeslots(timeslots.sort((x, y) => dayjs(y.start).isSameOrAfter(dayjs(x.start)) ? -1 : 1));
  }

  render() {
    const {
      isDisplayRange,
      isShowRemainingSpace,
      isShowWaitlist,
      onItemClick,
      timeZone,
      timeFormat,
      selectedTimeSlot,
      style,
      quantity,
      getAvailability,
      translation,
      variant,
    } = this.props;

    const slots = this.parseTimeSlots().map((timeslot) => {
      const availability = getAvailability(timeslot);
      const availableTimeSlot = availability >= quantity;

      return (
        <li key={timeslot.id} className="time-slot-radio-button-list-element">
          <TimeSlotRadioButton
            disabled={!(availableTimeSlot)}
            onClick={(event) => {
              onItemClick(timeslot, event);
            }}
            timeslot={timeslot}
            isDisplayRange={isDisplayRange}
            isShowRemainingSpace={isShowRemainingSpace}
            isShowWaitlist={isShowWaitlist}
            availableSpace={availability}
            timeZone={timeZone}
            timeFormat={timeFormat}
            quantity={quantity}
            selectedTimeSlot={selectedTimeSlot}
            style={style}
            translation={translation}
            variant={variant}
          />
        </li>
      );
    });

    return <ul className="time-slot-radio-button-list">{slots}</ul>;
  }
}

TimeSlotRadioButtons.propTypes = {
  timeslots: PropTypes.array,
  timeZone: PropTypes.string,
  locale: PropTypes.string,
  isDisplayRange: PropTypes.bool,
  isShowRemainingSpace: PropTypes.bool,
  availableDates: PropTypes.array,
  timeFormat: PropTypes.string,
  selectedDate: PropTypes.any,
  onItemClick: PropTypes.func,
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};
